import { type ConsentInfoResponse } from '@logto/schemas';

/** Display formatting only; the original account and callback remain authoritative. */
export class ConsentPresentation {
  static maskIdentifier(value: string): string {
    const trimmed = value.trim();
    if (/^\+?[\d\s()-]+$/.test(trimmed)) {
      const digits = trimmed.replace(/\D/g, '');
      return digits.length > 4 ? `•••• ${digits.slice(-4)}` : '••••';
    }
    const at = trimmed.lastIndexOf('@');
    if (at > 0) {
      return `${trimmed.slice(0, 1)}***${trimmed.slice(at)}`;
    }
    return trimmed;
  }

  constructor(private readonly user: ConsentInfoResponse['user']) {}

  get account() {
    const { user } = this;
    const name = [user.name, user.username]
      .map((value) => value?.trim())
      .find((value) => value && value !== user.id);
    const identifier = user.primaryPhone ?? user.primaryEmail;
    return {
      name: name ? ConsentPresentation.maskIdentifier(name) : undefined,
      identifier: identifier ? ConsentPresentation.maskIdentifier(identifier) : undefined,
    };
  }
}
